import { createActions } from 'redux-actions';

import { ENDPOINTS_USER } from '../../config/';
import {
  BaseAchievementElement,
  BaseAchievementElementsIO,
} from '../../reducers/DashboardReducer/AchievementsReducer/AchievementsReducer.types';
import { defaultErrorMessage, globalFetch, ioTsValidationError, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';

export const { dashboardAchievementsResponse, dashboardAchievementsRequest, dashboardAchievementsResponseFailure } = createActions(
  {
    DASHBOARD_ACHIEVEMENTS_RESPONSE: (data: BaseAchievementElement[]) => ({ data }),
  },
  'DASHBOARD_ACHIEVEMENTS_REQUEST',
  'DASHBOARD_ACHIEVEMENTS_RESPONSE_FAILURE'
);

export function getDashboardAchievements() {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();
    if (state.getIn(['dashboard', 'achievements', 'isfetching']) === true) {
      return dispatch(dashboardAchievementsRequest());
    }

    dispatch(dashboardAchievementsRequest());

    return globalFetch(
      `${ENDPOINTS_USER.user}/self/achievements`,
      {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      },
      dispatch,
      () => dispatch(dashboardAchievementsResponseFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'DASHBOARD_ACHIEVEMENTS_RESPONSE_FAILURE')) {
          return json;
        } else if (BaseAchievementElementsIO.decode(json).isRight()) {
          return dispatch(dashboardAchievementsResponse(json));
        } else {
          // It will be reported to sentry the io-ts validation errors
          ioTsValidationError(json, BaseAchievementElementsIO);

          return dispatch(dashboardAchievementsResponseFailure());
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(dashboardAchievementsResponseFailure());
      });
  };
}
